import { zodResolver } from '@hookform/resolvers/zod';
import { TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import type { TriggerCommitmentUsageReportJobParameters } from '@vy/api-definition';
import { TriggerCommitmentUsageReportJobParametersSchema } from '@vy/api-definition';
import { REPORT_JOB_TYPES } from '@vy/types';
import { vyDate } from '@vy/utils';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import type { TriggerReportJobFormProps } from '../TriggerReportJobDialog';

export const TriggerCommitmentUsageReportJobForm: React.FC<TriggerReportJobFormProps> = ({
  onSubmit,
  dialogActions,
}) => {
  const methods = useForm<TriggerCommitmentUsageReportJobParameters>({
    resolver: zodResolver(TriggerCommitmentUsageReportJobParametersSchema),
    defaultValues: {
      reportJobType: REPORT_JOB_TYPES.CommitmentUsage,
      upToDate: vyDate(undefined, { keepLocalTime: true }).endOf('day').toDate(),
    },
  });

  const reportNameRegister = methods.register('reportName');
  const handleSubmit = methods.handleSubmit((data) =>
    onSubmit({
      ...data,
      upToDate: vyDate(data.upToDate).endOf('day').toDate(),
    }),
  );

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit}>
        <div className="mt-3 flex flex-col items-start">
          <TextField 
            {...reportNameRegister} 
            className="w-full" 
            placeholder="Report name"
            onKeyDown={(e) => e.stopPropagation()}
          />
          <div className="flex w-full items-center gap-3">
            <Typography className="shrink-0">Contract start date -</Typography>
            <Controller
              control={methods.control}
              name="upToDate"
              render={({ field }) => (
                <DatePicker
                  {...field}
                  className="my-6 grow"
                  label="Report end date"
                  onChange={(date) => field.onChange(date?.toDate())}
                  value={vyDate(field.value)}
                />
              )}
            />
          </div>
        </div>
        {dialogActions}
      </form>
    </FormProvider>
  );
};
